(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/page-load.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/page-load.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  services
} = svs.components.chat.chatData;
const CHAT_PAGE_LOAD_INIT = 'CHAT/CHAT_PAGE_LOAD_INIT';
const CHAT_PAGE_LOAD_SUCCESS = 'CHAT/CHAT_PAGE_LOAD_SUCCESS';
const CHAT_PAGE_LOAD_FAILURE = 'CHAT/CHAT_PAGE_LOAD_FAILURE';
const CHAT_PAGE_LOAD_CLOSED = 'CHAT/CHAT_PAGE_LOAD_CLOSED';
const {
  constants
} = svs.components.chat.chatData;
const fetchMessagesByRoomId = function (roomId) {
  let {
    reset = false,
    fetchRoom = true
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (dispatch, getState) => {
    const chatState = getState().Chat;
    if ((chatState.rooms[roomId] || {}).loading) return;
    const finalCallback = (err, results) => {
      if (err) {
        dispatch({
          type: CHAT_PAGE_LOAD_FAILURE,
          error: 'Det gick inte att initiera chatten',
          roomId
        });
      } else {
        const [result1, result2] = results;
        dispatch(_objectSpread(_objectSpread({
          type: CHAT_PAGE_LOAD_SUCCESS,
          roomId
        }, result1), {}, {
          room: result2,
          reset
        }));
      }
    };
    dispatch({
      type: CHAT_PAGE_LOAD_INIT,
      roomId
    });
    const oldestMessageId = !reset ? (chatState.messages[roomId] || [{}])[0].id : undefined;
    async.waterfall([callback => {
      if (fetchRoom) {
        services.getChatRoom(roomId, callback);
      } else {
        callback(null, {
          name: '',
          status: 'Open'
        });
      }
    }, (response, callback) => {
      if (response.status === constants.ROOM_STATUS_CLOSED && response.isCurrentChatRoomMemberBlocked) {
        return finalCallback(undefined, [{}, response]);
      }
      services.fetchMessages(roomId, oldestMessageId, (err, data) => {
        if (err && err.status === 403) {
          return dispatch({
            type: CHAT_PAGE_LOAD_CLOSED,
            roomId
          });
        }
        callback(err, [data, response]);
      });
    }], finalCallback);
  };
};
setGlobal('svs.components.chat.chatData.actions', {
  CHAT_PAGE_LOAD_INIT,
  CHAT_PAGE_LOAD_SUCCESS,
  CHAT_PAGE_LOAD_FAILURE,
  CHAT_PAGE_LOAD_CLOSED,
  fetchMessagesByRoomId
});
 })(window);